<template>
  <NuxtLayout>
    <div>
      <div class="search_row">
        <div class="search_row_box">
          <el-input
            v-model="map.value"
            class="search_input"
            placeholder="请输入内容..."
            @keyup.enter="getList"
          />
          <el-button
            type="primary"
            class="search_btn"
            @click="getList"
          >
            <i class="iconfont icon-icon_Search" />
            <span class="font16">搜索</span>
          </el-button>
        </div>
      </div>
      <div class="search_history_row">
        <div class="white_space" />
        <div
          v-if="map.searchHistory.length > 0"
          class="search_history_row_box"
        >
          <div class="historys">
            <template v-for="(item,index) in map.searchHistory">
              <div
                v-if="index < 10"
                :key="index"
                @click="clickHistory(item)"
              >
                {{ item }}
              </div>
            </template>
          </div>
          <div
            class="delete"
            @click="deleteHistory"
          >
            <el-icon><delete /></el-icon>
            <span>删除</span>
          </div>
        </div>
      </div>
      <div class="content_box">
        <div class="category_list">
          <span
            v-for="(i, index) in map.tabList"
            :key="index"
            class="items"
            :class="{ active: map.tab === i.tabType }"
            @click="clickItem(i.tabType)"
          >{{ i.name }}</span>
        </div>
        <div v-loading="ctrl.loading">
          <template v-if="map.tab === 1">
            <index-course
              class="box_layout"
              :visible="map.list.length > 0"
              :component-info="{config:{showType:1},data:map.list}"
            />
          </template>
          <template v-if="map.tab === 2">
            <index-grade
              class="box_layout"
              :component-info="{config:{},data:map.list}"
            />
          </template>
          <template v-if="map.tab === 3">
            <teacher-list :list="map.list" />
          </template>
          <template v-if="map.tab === 4">
            <article-list :list="map.list" />
          </template>
        </div>
      </div>
      <div
        v-if="page.totalPage > 1"
        class="pagination"
      >
        <el-pagination
          v-model:currentPage="page.pageCurrent"
          v-model:pageSize="page.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="page.totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { teacherSearch } from '@/api/teacher.js'
import { courseSearch } from '@/api/course.js'
import { articleSearch } from '@/api/article.js'
import { gradeSearch } from '@/api/grade.js'
import { getStore, setStore } from '@/utils/storage'
import { Delete } from '@element-plus/icons-vue'
import cookie from '@/utils/cookies'

const cookieData = cookie.getShop()
useHead({
  title: '搜索结果-' + cookieData.shopName
})
const route = useRoute()
const map = reactive({
  value: route.query.t || '',
  tab: 1,
  list: [],
  searchHistory: [],
  tabList: [
    {
      name: '课程',
      tabType: 1
    },
    {
      name: '班级',
      tabType: 2
    },
    {
      name: '讲师',
      tabType: 3
    },
    {
      name: '资讯',
      tabType: 4
    }
  ]
})
const page = reactive({
  totalCount: 0,
  pageCurrent: 1,
  pageSize: 20,
  totalPage: 1
})
const ctrl = reactive({
  loading: false
})

watch(route, (newValue, oldValue) => {
  map.value = newValue.query.t
  getList()
})
const handleCurrentChange = (v) => {
  page.pageCurrent = v
  document.querySelector('#app').scrollTop = 0
  getList(false)
}
const clickItem = (d) => {
  map.tab = d
  getList()
}
const clickHistory = (d) => {
  map.value = d
  getList()
}
const deleteHistory = () => {
  map.searchHistory = []
  setStore('searchHistory', map.searchHistory)
}
const getCoursePage = () => {
  ctrl.loading = true
  courseSearch({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    searchContent: map.value
  }).then((res) => {
    if (res) {
      map.list = res.list || []
      page.pageCurrent = res.pageCurrent
      page.totalCount = res.totalCount
      page.totalPage = res.totalPage
    }
    ctrl.loading = false
  }).catch(() => {
    ctrl.loading = false
  })
}
const getGradePage = () => {
  ctrl.loading = true
  gradeSearch({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    searchContent: map.value
  })
    .then((res) => {
      if (res) {
        map.list = res.list || []
        page.pageCurrent = res.pageCurrent
        page.totalCount = res.totalCount
        page.totalPage = res.totalPage
      }
      ctrl.loading = false
    })
    .catch(() => {
      ctrl.loading = false
    })
}
const getTeacherPgae = () => {
  ctrl.loading = true
  teacherSearch({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    searchContent: map.value
  })
    .then((res) => {
      if (res) {
        map.list = res.list || []
        page.pageCurrent = res.pageCurrent
        page.totalCount = res.totalCount
        page.totalPage = res.totalPage
      }
      ctrl.loading = false
    })
    .catch(() => {
      ctrl.loading = false
    })
}
const getArticlePage = () => {
  ctrl.loading = true
  const d = {
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    searchContent: map.value
  }
  articleSearch(d)
    .then((res) => {
      if (res) {
        map.list = res.list || []
        page.pageCurrent = res.pageCurrent
        page.totalCount = res.totalCount
        page.totalPage = res.totalPage
      }
      ctrl.loading = false
    })
    .catch(() => {
      ctrl.loading = false
    })
}
const getList = (bool = true) => {
  if (bool) {
    page.pageCurrent = 1
    page.pageSize = 20
    map.list = []
  }
  if (map.value) {
    if (map.searchHistory.indexOf(map.value) > -1) {
      const index = map.searchHistory.indexOf(map.value)
      map.searchHistory.splice(index, 1)
      map.searchHistory.unshift(map.value)
    } else {
      map.searchHistory.unshift(map.value)
    }
    setStore('searchHistory', map.searchHistory)
  }
  if (map.tab === 1) {
    getCoursePage()
  }
  if (map.tab === 2) {
    getGradePage()
  }
  if (map.tab === 3) {
    getTeacherPgae()
  }
  if (map.tab === 4) {
    getArticlePage()
  }
}
onMounted(() => {
  map.value = route.query.t
  map.tab = route.query.tab ? +route.query.tab : 1
  if (!getStore('searchHistory')) {
    setStore('searchHistory', [])
  } else {
    map.searchHistory = JSON.parse(getStore('searchHistory'))
  }
  getList()
})
</script>

<style lang="scss" scoped>
.box_layout{
  margin-top: -20px;
}
.search_row {
  position: fixed;
  top: 66px;
  background: #fff;
  width: 100%;
  z-index: 100;
}
.search_row_box {
  width: 1020px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  margin-bottom: 10px;
  .search_input {
    width: 880px;
    height: 50px;
    font-size: 14px;
    :deep(.el-input__inner) {
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
    }
  }
  .search_btn {
    width: 130px;
    height: 50px;
    .icon-icon_Search {
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
.search_history_row {
  width: 100%;
  background: #fff;
  .white_space {
    height: 80px;
    background: #fff;
    width: 100%;
  }
}
.search_history_row_box {
  width: 1020px;
  margin: auto;
  display: flex;
  column-gap: 10px;
}
.historys {
  width: 880px;
  div {
    padding: 5px 10px;
    background: #F6F8FB;
    border-radius: 5px;
    display: inline-block;
    margin: 0 10px 10px 0;
    cursor: pointer;
  }
}
.delete {
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  column-gap: 2px;
  color: #F61818;
  background: #F6F8FB;
  border-radius: 5px;
  cursor: pointer;
}
.content_box {
  width: 1200px;
  margin: auto;
}
.category_list {
  margin-top: 20px;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  padding-bottom: 0;
  margin-bottom: 20px;
  .items {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 5px;
    padding: 1px 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
  }
  .active {
    color: #2256f6;
    background: #fff;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 20px;
      height: 3px;
      background: #2256f6;
      bottom: 0px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
.pagination {
  text-align: center;
  margin-bottom: 30px;
}
</style>
